module.exports = __webpack_public_path__ + "static/media/turtle.05a2e681.png";